import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "header-padding" }, "Switch Devices", -1)

import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { formatStringDate as formatDate } from '@/utils'

import { SwitchDeviceArgs, SwitchDeviceSchema } from '@/generated/sdk'


export default /*#__PURE__*/_defineComponent({
  __name: 'SwitchDevices',
  setup(__props) {

const store = useStore()

const switches = computed<SwitchDeviceSchema[]>(() => store.state.devices.switches)

onMounted(async () => await loadSwitches({ page: 1, size: 10 }))

async function onPage(event) {
  await loadSwitches({ page: event.page + 1, size: event.rows })
}

async function loadSwitches(queryArgs: SwitchDeviceArgs): Promise<void> {
  store.dispatch('loadSwitches', queryArgs)
}

function formatId(id: string): string {
  return id.split('/')[3]
}

function formatPolicyName(id: string): string {
  return store.state.policies.mdmPolicies.find(m => m.googleId === id).name
}

return (_ctx: any,_cache: any) => {
  const _component_DodoRow = _resolveComponent("DodoRow")!
  const _component_PrimeColumn = _resolveComponent("PrimeColumn")!
  const _component_CheckMark = _resolveComponent("CheckMark")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_DodoColumn = _resolveComponent("DodoColumn")!

  return (_openBlock(), _createBlock(_component_DodoColumn, null, {
    default: _withCtx(() => [
      _createVNode(_component_DodoRow, null, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      (switches.value)
        ? (_openBlock(), _createBlock(_component_DataTable, {
            key: 0,
            lazy: true,
            "total-records": 100000,
            value: switches.value,
            "data-key": "id",
            "responsive-layout": "scroll",
            paginator: true,
            rows: 10,
            "paginator-template": "CurrentPageReport PrevPageLink NextPageLink RowsPerPageDropdown",
            "rows-per-page-options": [10, 50, 100],
            "current-page-report-template": "Showing {first} to {last}",
            onPage: _cache[0] || (_cache[0] = ($event: any) => (onPage($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PrimeColumn, {
                field: "device.id",
                header: "ID"
              }, {
                body: _withCtx(({data}) => [
                  _createTextVNode(_toDisplayString(data.device ? formatId(data.device.id) : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_PrimeColumn, {
                field: "device.lastPolicySyncTime",
                header: "Last policy sync time"
              }, {
                body: _withCtx(({data}) => [
                  _createTextVNode(_toDisplayString(data.device ? _unref(formatDate)(data.device.lastPolicySyncTime) : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_PrimeColumn, {
                field: "device.lastStatusReportTime",
                header: "Last status report time"
              }, {
                body: _withCtx(({data}) => [
                  _createTextVNode(_toDisplayString(data.device ? _unref(formatDate)(data.device.lastStatusReportTime) : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_PrimeColumn, {
                field: "device.hardwareInfo.serialNumber",
                header: "Serial number"
              }),
              _createVNode(_component_PrimeColumn, {
                field: "imei",
                header: "IMEI"
              }),
              _createVNode(_component_PrimeColumn, {
                field: "kioskPolicy",
                header: "Kiosk policy"
              }, {
                body: _withCtx(({data}) => [
                  _createTextVNode(_toDisplayString(formatPolicyName(data.kioskPolicy)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_PrimeColumn, {
                field: "normalPolicy",
                header: "Normal policy"
              }, {
                body: _withCtx(({data}) => [
                  _createTextVNode(_toDisplayString(formatPolicyName(data.normalPolicy)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_PrimeColumn, {
                field: "device.policyName",
                header: "On normal policy"
              }, {
                body: _withCtx(({data}) => [
                  _createVNode(_component_CheckMark, {
                    checked: data.normalPolicy === data.device?.policyName
                  }, null, 8, ["checked"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})